import { BillingAction } from './../../../state-management/billing/billing.action';
import { Component, Inject, ElementRef, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DialogComponentContent } from '../../../models/dialogs/DialogComponentContent';
import { HubAuthorizationComponent } from '../../../components/hub-authorization/hub-authorization.component';
import { AuthorizationWraperService } from '../../../services/authorization-wraper/authorization.wraper.service';
import { AuthorizationScenario } from '../../../enum/authorization-scenario.enum';
import { AuthorizationResultPayload } from '../../../models/authorization/authorization-result-payload.model';
import { UserProfileActions } from '../../../state-management/userprofile/userprofile.actions';
import { AppState } from '../../../interfaces/app-state.interface';
import { RiskModel } from '../../../enum/risk-model.enum';
import { AgreementsAction } from '../../../state-management/agreements/agreements.action';
import { AgreementsOptions } from '../../../enum/agreement/agreements-options.enum';
import { StorageService } from '../../../services/storage.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

const toroBetaCookie = 'hub$toro$beta';

@AutoUnsubscribe()
@Component({
    selector: 'dialog-brokerage-zero',
    templateUrl: './brokerage-zero.component.html',
    styleUrls: ['./brokerage-zero.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class BrokerageZeroComponent extends DialogComponentContent {

    public termsForm: FormGroup;
    public fromComponent = {
        name: null,
    };

    private disposableSubscriptions: Subscription[] = [];
    private agreementsToAccept: any[] = [];
    private riskModelGuid: string = AgreementsOptions.TermoAdesaoModelo2Risco.toLowerCase();
    private rlpGuid: string = AgreementsOptions.TermoAdesaoRlp.toLowerCase();
    private billingGuid: string = AgreementsOptions.TermoAdesaoToroZero.toLowerCase();

    constructor(
        @Inject(MAT_DIALOG_DATA) private data,
        public elementRef: ElementRef,
        private formBuilder: FormBuilder,
        private dialogReference: MatDialogRef<BrokerageZeroComponent>,
        private authorizationPanel: MatDialogRef<HubAuthorizationComponent>,
        private authorizationWraperService: AuthorizationWraperService,
        private store: Store<AppState>,
    ) {
        super(elementRef, '.modal-terms');
        this.termsForm = this.formBuilder.group({
            agree: [false, Validators.required],
        });

        this.bindAgreementSubscription();
        this.getDatasFromComponet();

    }

    public ngOnInit() {
        this.bindDispatchs();
    }

    // AutoUnsubscribe reponsavel pelo unsubscribe
    public ngOnDestroy() {
        //
    }

    /* Encerra o componente informando se há confirmação para realizar o
     * investimento
     * @param confirm confirmação para realizar ou não do investimento.
     */
    public dispose(confirm: boolean = false) {
        super.close(this.dialogReference, confirm);
    }

    public formSubmitHandler(event: Event) {
        event.preventDefault();

        this.authorizationPanel = this.authorizationWraperService.requestUserAuthorization(AuthorizationScenario.AuthenticateUserUsingSmsToken);

        this.disposableSubscriptions.push(
            this.authorizationPanel.componentInstance.onTokenAvaliable
                .subscribe((token: AuthorizationResultPayload) => {
                    // Altera o modelo de risco do usuário
                    this.store.dispatch({ type: UserProfileActions.updateRiskModel, payload: RiskModel.Two.toString(), ...token });

                    // Aceita o contrato do modelo de risco parametrizado
                    if (!!this.agreementsToAccept.length) {
                        this.agreementsToAccept.forEach((agreement) => {
                            if (agreement && agreement.contractGuid) {
                                this.store.dispatch({
                                    type: AgreementsAction.acceptAgreement, payload: {
                                        contractGuid: agreement.contractGuid,
                                        versionId: agreement.versionID,
                                        status: true,
                                        agreementId: agreement.id,
                                    },
                                });
                            }
                        });

                        this.store.dispatch({
                            type: BillingAction.setBrokerageModel,
                            payload: { modelName: 'torozero' },
                        });

                        this.authorizationPanel.close();
                        this.dispose(true);

                    } else {

                        this.authorizationPanel.close();
                        this.dispose(false);

                    }
                }),
        );
    }

    public bindAgreementSubscription() {

        this.disposableSubscriptions.push(
            this.store.select((state) => state.agreements.agreements)
                .pipe(
                    filter((agreements) => agreements[this.riskModelGuid] || agreements[this.billingGuid] || agreements[this.rlpGuid]),
                )
                .subscribe((agreements) => {
                    Object.keys(agreements)
                        .map((agreementGuid) => {
                            const alreadyExists = this.alreadyHasAgreement(agreementGuid);
                            if (!alreadyExists) this.agreementsToAccept.push(agreements[agreementGuid]);
                        });
                }),
        );
    }

    public bindDispatchs() {
        this.store.dispatch({ type: AgreementsAction.getAgreementData, payload: AgreementsOptions.TermoAdesaoModelo2Risco });
        this.store.dispatch({ type: AgreementsAction.getAgreementData, payload: AgreementsOptions.TermoAdesaoRlp });
        this.store.dispatch({ type: AgreementsAction.getAgreementData, payload: AgreementsOptions.TermoAdesaoToroZero });
    }

    private alreadyHasAgreement(agreementGuid: string): boolean {
        return !!this.agreementsToAccept.find((agreement) => agreement.contractGuid === agreementGuid);
    }

    private getDatasFromComponet() {

        if (!this.data) { return; }

        if (!!this.data.from) {
            this.fromComponent.name = this.data.from;
        }

    }

}
